import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'secToMin'
})
export class SecToMinPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value > 0) {
      return value / 60;
    }
    return 0;
  }

}
